goog.provide('el8.app.shared.network.viewEditConnection');

goog.require('el8.data.physicians');
goog.require('el8.app.shared.network.mappedProfileDetails');
goog.require('el8.app.shared.network.unmappedProfileDetails');

el8.app.shared.network.viewEditConnection = (function() {

    return {
        show: function(spec) {
            if(el8Globals.FEATURES.NewContactEPN) {
                var mapped = false;
                if (spec.contactId) {
                    var contact = el8.data.physicians.getById(spec.contactId);
                    mapped = contact.isMapped()
                }
                el8React.dispatch.openContactDialog({
                    physicianId: spec.contactId, 
                    physicianName: spec.contactName, 
                    isMapped: mapped, 
                    updatedContactCallback: spec.callbackFn,
                });
            } 
            else {
                spec = spec || {};
                if (!spec.contactId && !spec.contactName) { return; }

                /* If we have a contact and it's mapped, show the profile details dialog */
                if (spec.contactId) {
                    var contact = el8.data.physicians.getById(spec.contactId);
                    if (contact && contact.isMapped()) {
                        el8.app.shared.network.mappedProfileDetails.show(spec);
                        return;
                    }
                }
                /* Otherwise, show the dialog for unmapped contacts */
                el8.app.shared.network.unmappedProfileDetails.show(spec);
            }
        }
    };

})();

